import React, { useState, useEffect, useCallback } from 'react';
import DataTable from '../Components/DataTable/DataTable';
import ListPage from '../Components/ListPage/ListPage';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Controllers from '../Api/Controllers';
import { FormCustom, Input } from '../Components/Form/Form';
import Helpers from '../Helpers/Helpers';
import { toast as toastr } from 'react-toastify';
import Row from './Row';
import {useSelector} from 'react-redux'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const GroupsForm = ({ data, onSubmit, viewDisabled }) => {
  const {
    id = '',
    description = ''
  } = data

  const [exists, setExists] = useState(id !== '') 
  const [row, setRow] =useState({
    id,
    description
  })

  const dataSumbit = useCallback(() => {
    return {
      p_id: row.id,
      p_description: row.description
    }
  }, [row])

  return <>
    <FormCustom dataSubmit={dataSumbit()} onSubmit={onSubmit} callbackSuccess={idGroup => setExists(true)} viewSubmit={!viewDisabled}>
      <Input
        text="ID"
        placeholder="ID"
        classNameParent="col-12 mb-2"
        icon="fa fa-code"
        required
        defaultValue={id}
        onChange={e => setRow({ ...row, id: e.currentTarget.value })}
        disabled={id !== ''}
        pattern="[0-9]{1,5}"
        invalid="Solo números. Ej. 0, 10, 100"
        maxLength={5}
      />
      <Input
        text="Descripción"
        placeholder="Descripción"
        classNameParent="col-12 mb-2"
        icon="far fa-comment-alt"
        required
        defaultValue={description}
        onChange={e => setRow({ ...row, description: e.currentTarget.value })}
        maxLength={255}
        disabled={viewDisabled}
      />
    </FormCustom>
    {exists ? <>
      <div className="mt-4"></div>
      <Row idGroup={row.id} />
    </> : ''}
  </>
}

const Groups = () => {
  const nameModulo = 'Grupos'
  const namePage = 'Grupo'
  const nameController = 'group'

  const permissions = useSelector(store => store.session.permissions)
  const actionsModule = Helpers.getActions({ permissions, name: 'grupos' })

  const thead = [
    { name: 'ID', align: 'center' },
    { name: 'Descripción' },
    { name: 'Acc.', align: 'center' }
  ];

  const [rows, setRows] = useState([]);
  const [isProcessing, setIsProcessing] = useState(true);
  const [modalSize, setModalSize] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [modalHeader, setModalHeader] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [form, setForm] = useState('');
  const [reload, setReload] = useState(true);

  useEffect(() => {
    if (reload) {
      Controllers[nameController]['get_' + nameController]().then(res => {
        setRows(res.data)
      })
      .finally(() => {
        setIsProcessing(false)
        setReload(false);
      });
    }
  }, [reload])

  const handleUpdate = e => {
    const { id = '', disabled = 0 } = e.currentTarget.dataset;
    let button = e.currentTarget
    let buttonHTML = button.innerHTML;
    button.innerHTML = Helpers.icon.spin()
    
    setModalTitle(parseInt(disabled) === 1 ? <><i className={'mr-2 ' + actionsModule.view.icon}></i>{actionsModule.view.description} {namePage}</> : (id ? <><i className={'mr-2 ' + actionsModule.update.icon}></i>{actionsModule.update.description} {namePage}</> : <><i className={'mr-2 ' + actionsModule.create.icon}></i>{actionsModule.create.description} {namePage}</>))
    setModalSize('lg');
    setModalHeader('');

    Controllers[nameController]['get_' + nameController + '_id']({ p_id: id }).then(res => {
      setForm(<>
        <GroupsForm data={res.data} onSubmit={onSubmit} viewDisabled={parseInt(disabled) === 1} />
      </>);
      setModalShow(true);
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
      setModalShow(false);
    }).finally(() => button.innerHTML = buttonHTML)
  }

  const onSubmit = ({ e, dataSubmit, callbackSuccess }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers[nameController][nameController + '_insert_update'](dataSubmit).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      if (res.response === 'success') {
        callbackSuccess(res.data.id);
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
      setReload(true)
    });
  }

  const onDelete = e => {
    const { id = '' } = e.currentTarget.dataset;
    setModalTitle(<><i className="fa fa-trash mr-2"></i> Eliminar {namePage}</>);
    setModalHeader('bg-danger');
    setModalSize('sm');
    setForm(<div className="d-flex flex-column align-items-center">
      <p><strong>¿Eliminar {namePage} #{id}?</strong></p>

      <div>
        <Button variant="danger"  size="sm" onClick={e => {
          let button = e.currentTarget
          let buttonHTML = button.innerHTML;
          button.innerHTML = Helpers.icon.spin()

          Controllers[nameController][nameController + '_delete']({
            p_id: id
          }).then(res => {
            Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
          }).catch(req => {
            Helpers.promise.catch({ req, toastr });
          }).finally(() => {
            button.innerHTML = buttonHTML;
            setReload(true)
            setModalShow(false);
          });
        }}>
          <i className="fa fa-check mr-2"></i>Si
        </Button>
        <Button variant="dark" className="ml-2" size="sm" onClick={() => setModalShow(false)}>
          <i className="fa fa-times mr-2"></i>No
        </Button>
      </div>
    </div>);
    setModalShow(true)
  }

  return <> 
    <ListPage
      title={<>Listado De {nameModulo}</>}
      subtitle="Gestioná el listado y las acciones disponibles."
      actions={<>{actionsModule.create ? <Button onClick={handleUpdate} variant={actionsModule.create.color} size="sm"><i className={ actionsModule.create.icon}></i><span className="ml-2 d-none d-md-inline-block">{actionsModule.create.description} {namePage}</span></Button> : ''}</>}
    >
      <DataTable
          isProcessing={isProcessing}
          tbody={rows}
          thead={thead}
          render={tbody => tbody.map(r => {
            let rowRender = [];
            let i = 0;
            for (let key in r) {
              rowRender.push(<td align={thead[i].align ? thead[i].align : ''}>{r[key]}</td>);
              i++;
            }

            rowRender.push(<td align={thead[i].align ? thead[i].align : ''}>
          

              {actionsModule.view ?  <OverlayTrigger
                placement="top"
                overlay={props => <Tooltip {...props}>
                  {actionsModule.view.description}
                </Tooltip>}
              >
                <Button variant={actionsModule.view.color} data-disabled={1} size="xs" className="mr-1" data-id={r.id} onClick={handleUpdate}>
                  <i className={actionsModule.view.icon}></i>
                </Button>
              </OverlayTrigger> : ''}
              {actionsModule.update ?  <OverlayTrigger
                placement="top"
                overlay={props => <Tooltip {...props}>
                  {actionsModule.update.description}
                </Tooltip>}
              >
                <Button variant={actionsModule.update.color} size="xs" className="mr-1" data-id={r.id} onClick={handleUpdate}>
                  <i className={actionsModule.update.icon}></i>
                </Button>
              </OverlayTrigger> : ''}
              {actionsModule.delete ? <OverlayTrigger
                placement="top"
                overlay={props => <Tooltip {...props}>
                  {actionsModule.delete.description}
                </Tooltip>}
              >
                <Button variant={actionsModule.delete.color} size="xs" data-id={r.id} onClick={onDelete}>
                  <i className={actionsModule.delete.icon}></i>
                </Button>
              </OverlayTrigger> : ''}
          
        </td>);
            return (<tr>
              {React.Children.toArray(rowRender)}
            </tr>);
          })}
        />
    </ListPage>
    <Modal show={modalShow} onHide={() => setModalShow(false)} size={modalSize} backdrop="static">
      <Modal.Header closeButton className={modalHeader}>
        <Modal.Title as="div">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {form}
      </Modal.Body>
    </Modal>
  </>
}

export default Groups;